// extracted by mini-css-extract-plugin
export default {"img":"Book_img__l9zto","desc":"Book_desc__IrizV","container":"Book_container__RXHlc","titles":"Book_titles__Tn4GU"};